
// 加载字体
function loadFonts() {
    let fontList = customData.engravingSettings.fontList;
    var styleLoadDom = "";
    for (let i = 0; i < fontList.length; i++) {
        if (!fontList[i].file) {
            continue;
        }
        new FontFace(fontList[i].fontName, "url(" + fontList[i].file + ")").load();
        styleLoadDom += `
            @font-face {
                font-family: "${fontList[i].fontName}";
                src: url('${fontList[i].file}') format('woff');
            }
        `;
    }
    $('<style>', { id: 'customFontStyle' }).css({}).text(styleLoadDom).appendTo('body');
}

// 字体节点
function initFontDom() {
    let fontList = customData.engravingSettings.fontList;
    currentFont = fontList[0].fontName;
    if (fontList.length < 2) return;
    setProductOptions("Font", currentFont);

    let fontListDom = '';
    fontList.map((font, index) => {
        if (index > 0)
            fontListDom += `<span class="cc-font-item" data-font="${font.fontName}"><span class="cc-font-item-abc" style="font-family: ${font.fontName}">ABC</span><span class="cc-font-item-name">${font.name}</span></span>`;
        else
            fontListDom += `<span class="cc-font-item cc-font-selected" data-font="${font.fontName}"><span class="cc-font-item-abc" style="font-family: ${font.fontName}">ABC</span><span class="cc-font-item-name">${font.name}</span></span>`;
    });

    let dom = `
    <div class="cc-popup-section">
        <div class="cc-popup-section-title">
            <span>Choose Your Font</span>
        </div>
        <div class="cc-popup-section-inner cc-font-list">
            ${fontListDom}
        </div>
    </div>
    `;

    $(".cc-popup-section-continer").append(dom);
}

// 生辰石选择节点
function initBirthStoneDom() {
    let listDom = "";

    birthStoneList.map(v => {
        listDom += `
            <div class="cc-stone-color-item" data-color="${v.color}" data-month="${v.month}" data-name="${v.name}">
                <span class="cc-stone-color-color">
                    <i style="background-color: ${v.color};"></i>
                </span>
                <span class="cc-stone-color-name">${v.month}</span>
            </div>
        `;
    });

    birthStoneDom = `
        <div class="cc-stone-mask">
            <div class="cc-stone-mask-box">
                ${listDom}
            </div>
        </div>
    `;
}

// 石头节点
function initStoneDom() {
    customData.stoneSettings.stoneList.map((v, index) => {
        let titleDom = `
            <div class="cc-popup-stone">
                <div class="cc-popup-stone-title">
                    <span>${v.title}</span>
                </div>
                <div class="cc-popup-stone-current">
                    <span class="cc-popup-stone-color" style="display: none;"></span>
                    <span class="cc-popup-stone-name"></span>
                    <span class="cc-popup-stone-arrow"></span>
                </div>
            </div>
        `

        $(".cc-popup-section-continer").append(`
            <div class="cc-popup-section cc-popup-section-stone" data-index="${index}">
                ${titleDom}
                ${birthStoneDom}
            </div>
        `);
    })
}

// 设置图案
function setDesignList() {
    if (typeof customData.engravingSettings.designList != "object") {
        return;
    }

    designDom = "";
    designList = {};
    let listDom = "";
    customData.engravingSettings.designList.map(list => {
        let itemDom = "";
        list.subList.map(item => {
            itemDom += `<span>${item.text}</span>`;
            designList[item.text] = item.length;
        });
        listDom += `
            <div class="cc-engraving-design-item">
                <p class="cc-engraving-design-title">${list.title}</p>
                <div class="cc-engraving-design-list">${itemDom}</div>
            </div>
        `;
    })

    designDom = `
        <div class="cc-engraving-design">
            <div class="cc-engraving-design-box">${listDom}</div>
        </div>
    `;
}

// 刻字节点
function initEngravingDom() {
    customData.engravingSettings.engravingList.map((v, index) => {
        let titleDom = `
            <div class="cc-popup-section-title">
                <span>${v.title}</span>
                <span class="cc-engraving-limit"><span class="cc-engraving-limit-length">${v.engravingSize}</span> Characters Remaining</span>
            </div>
        `
        let tempDesignDom = "";

        if (customData.engravingSettings.engravingType == 2) {
            tempDesignDom = designDom;
        }

        let innerDom = `
            <div class="cc-popup-section-inner cc-engraving cc-engraving-type${customData.engravingSettings.engravingType}" data-index="${index}" data-length="${v.engravingSize}">
                <input type="text" placeholder="" class="cc-engraving-input" maxlength="${v.engravingSize}">
                ${tempDesignDom}
            </div>
        `

        $(".cc-popup-section-continer").append(`
            <div class="cc-popup-section">
                ${titleDom}
                ${innerDom}
            </div>
        `);
    })
}

// 切换字体
function changeFont(fontName) {
    currentFont = fontName;
    $(".cc-preview-text, .cc-popup-preview-sub-inner, .cc-engraving-input, .cc-engraving-design-list").css({
        fontFamily: fontName
    });

    if (typeof fontLineheightSetting[fontName] != "undefined") {
        $(".cc-preview-text").css({paddingTop: fontLineheightSetting[fontName] + "%"});
    } else {
        $(".cc-preview-text").css({paddingTop: "0"});
    }

    checkTextWidthState = 0;
    checkTextWidth();

    if (customData.engravingSettings.fontList.length < 2) {
        return;
    }
    
    setProductOptions("Font", fontName);
}

function checkTextWidth(isChangeText = true) {
    if ($(".cc-preview-text").width() > $(".cc-preview-text").parent().width() && (isChangeText || checkTextWidthState == 1)) {
        checkTextWidthState = 1;
        if (typeof customData.previewSettings.oldPreviewTextSize == "undefined") {
            customData.previewSettings.oldPreviewTextSize = customData.previewSettings.previewTextSize;
        }
        customData.previewSettings.previewTextSize -= 1;
        $(".cc-preview-text").css({fontSize: customData.previewSettings.previewTextSize + "px"});
        checkTextWidth(false);
    } else if ($(".cc-preview-text").parent().width() - $(".cc-preview-text").width() > 50 && customData.previewSettings.previewTextSize < customData.previewSettings?.oldPreviewTextSize && (isChangeText || checkTextWidthState == 2)) {
        checkTextWidthState = 2;
        customData.previewSettings.previewTextSize += 1;
        $(".cc-preview-text").css({fontSize: customData.previewSettings.previewTextSize + "px"});
        checkTextWidth(false);
    }
}

function checkTextWidth2(index, isChangeText = true) {
    if ($(".cc-preview-text-" + index)[0].scrollWidth > $(".cc-preview-text-" + index)[0].clientWidth && (isChangeText || checkTextWidthState2 == 1)) {
        checkTextWidthState2 = 1;
        if (typeof customData.previewSettings.previewFontsSettings[index].oldPreviewTextSize == "undefined") {
            customData.previewSettings.previewFontsSettings[index].oldPreviewTextSize = customData.previewSettings.previewFontsSettings[index].size;
        }
        customData.previewSettings.previewFontsSettings[index].size -= 1;
        $(".cc-preview-text-" + index).css({fontSize: customData.previewSettings.previewFontsSettings[index].size + "px"});
        checkTextWidth2(index, false);
    } else if ($(".cc-preview-text-" + index)[0].clientWidth - $(".cc-preview-text-" + index)[0].scrollWidth > 1 && customData.previewSettings.previewFontsSettings[index].size < customData.previewSettings.previewFontsSettings[index].oldPreviewTextSize && (isChangeText || checkTextWidthState2 == 2)) {
        checkTextWidthState = 2;
        customData.previewSettings.previewFontsSettings[index].size += 1;
        $(".cc-preview-text-" + index).css({fontSize: customData.previewSettings.previewFontsSettings[index].size + "px"});
        checkTextWidth2(index, false);
    }
}

// 文字变化
function changeText(text, index = 0) {
    if (customData.previewSettings.previewType == 3) {
        $(".cc-preview-text-" + index).text(text);
        checkTextWidthState2 = 0;
        if (typeof customData.previewSettings.previewFontsSettings[index].oldPreviewTextSize != "undefined") {
          customData.previewSettings.previewFontsSettings[index].size = customData.previewSettings.previewFontsSettings[index].oldPreviewTextSize;
          $(".cc-preview-text-" + index).css({fontSize: customData.previewSettings.previewFontsSettings[index].size + "px"});
        }
        checkTextWidth2(index);
    } else {
        let oldText = $(".cc-preview-text").text();
        console.log("zz", oldText, text);
        if (oldText != text) {
          $(".cc-preview-text").text(text);
          checkTextWidthState = 0;
          checkTextWidth();
        }
    }

    let key = customData.engravingSettings.engravingList[index].title;
    setProductOptions(key, text);
}

// 石头变化
function changeStone(month, index = 0) {
    let currentVariant = getCurrenrVariant();
    let key = month + "-" + currentVariant;
    let skey = customData.stoneSettings.stoneList[index].title;
    setProductOptions(skey, month);
    
    if (typeof customData.stoneSettings.stoneList[index].list[key] != "object") {
        return;
    }

    let tempset = customData.stoneSettings.stoneList[index].list[key];

    if (customData.stoneSettings.stoneImageType == 1) {
        $(".cc-preview-stone-" + index).css({
            backgroundPosition: `-${tempset.x}px -${tempset.y}px`,
            width: `${tempset.w}px`,
            height: `${tempset.h}px`,
        });
    } else {
        $(".cc-preview-stone-" + index + " img").attr("src", tempset.image).show();
    }
}

// 获取当前variant id
function getCurrenrVariant() {
    if (typeof document.querySelector("variant-selects").currentVariant != "undefined" && colorKey != null) {
        return document.querySelector("variant-selects").currentVariant[colorKey];
    }

    return defaultVariant;
}

// variant更新
function updVariantHandle(isForce = false) {
    let newVariant = getCurrenrVariant();
    console.log("zz", newVariant, currentVariantId);
    if (!isForce && newVariant == currentVariantId) return;

    currentVariantId = newVariant;
    console.log("zz", customData.previewSettings.previewVariantSettings[currentVariantId]);
    if (typeof customData.previewSettings.previewVariantSettings[currentVariantId] != "object") {
        return;
    }

    let tempset = customData.previewSettings.previewVariantSettings[currentVariantId];

    if (customData.previewSettings.previewType == 1) {
        $(".cc-popup-preview-sub").css({
            backgroundColor: tempset.bgColor,
        });
        $(".cc-preview-text").css({
            color: tempset.fontColor,
        });
    } else if (customData.previewSettings.previewType == 2) {
        $(".cc-popup-preview-sub").css({
            backgroundColor: tempset.bgColor,
        });
        $(".cc-preview-text").css({
            color: tempset.fontColor,
        });
        $(".cc-popup-preview-block").css({
            backgroundColor: tempset.blockColor,
        });
    } else if (customData.previewSettings.previewType == 3) {
        $(".cc-popup-review-bg").attr("src", tempset.bgImg);
        $(".cc-popup-preview-sub-inner").css({
            color: tempset.fontColor
        });
    }
}

// 预览节点缩放
function setPreviewScale() {
    let width = $(".cc-popup-preview").width();
    let scale = width / previewWidth;
    $(".cc-popup-preview-sub").css({
        width: previewWidth + "px",
        height: previewHeight + "px",
        transform: "scale(" + scale + ")"
    });
}

// 预览节点
function initPreviewDom() {
    let dom = "";
    if (customData.previewSettings.previewType == 1) {
        dom = `
            <span class="cc-preview-text" style="font-size: ${customData.previewSettings.previewTextSize}px;"></span>
        `;
        $(".cc-popup-preview-sub").html(dom);
    } else if (customData.previewSettings.previewType == 2) {
        let align = "center";
        if (customData.previewSettings.previewTextAlign == "left") {
            align = "start";
        } else if (customData.previewSettings.previewTextAlign == "right") {
            align = "end";
        }
        dom = `
            <div class="cc-popup-preview-block" style="width: ${customData.previewSettings.previewBlockWdith}px; height: ${customData.previewSettings.previewBlockHeight}px; justify-content: ${align}">
                <span class="cc-preview-text" style="font-size: ${customData.previewSettings.previewTextSize}px; white-space: nowrap;"></span>
            </div>
        `;
        $(".cc-popup-preview-sub").html(dom);
    } else if (customData.previewSettings.previewType == 3) {
        $(".cc-popup-preview-sub").html(`
            <img class="cc-popup-review-bg" src="">
            <div class="cc-popup-preview-sub-inner">
                <div class="cc-popup-preview-text-list"></div>
                <div class="cc-popup-preview-stone-list"></div>
            </div>
        `);
        initPreviewTextDom();
        initPreviewStoneDom();
        console.log(customData.stoneSettings.stoneImageType, customData.stoneSettings.stoneBigImage);
        if (customData.stoneSettings.stoneImageType == 1 && customData.stoneSettings.stoneBigImage) {
            var img = new Image();
            img.onload = function() {
                stoneImgScale = stoneBigImageSize / img.naturalWidth;
            };
            img.src = customData.stoneSettings.stoneBigImage;
        }
    }
}

// 刻字定制预览节点
function initPreviewTextDom() {
    let textDom = ``;
    customData.engravingSettings.engravingList.map((_, index) => {
        if (typeof customData.previewSettings.previewFontsSettings[index] != "undefined") {
            let tempset = customData.previewSettings.previewFontsSettings[index]
            textDom += `
                <span class="cc-preview-text-${index}" style="
                    font-size: ${tempset.size}px; 
                    left: ${tempset.x}px; 
                    top: ${tempset.y}px; 
                    transform: rotate(${tempset.angle}deg); 
                    width: ${tempset.w}px; 
                    height: ${tempset.h}px;
                    line-height: ${tempset.h}px;
                    text-align: ${tempset.align};
                    transform-origin: left top;
                "></span>
            `;
        }
    })
    $(".cc-popup-preview-text-list").html(textDom);
}

// 石头定制预览节点
function initPreviewStoneDom() {
    let stoneDom = "";
    customData.stoneSettings.stoneList.map((_, index) => {
        if (typeof customData.previewSettings.previewStoneSettings[index] != "undefined") {
            let tempset = customData.previewSettings.previewStoneSettings[index]
            let background = "";
            if (customData.stoneSettings.stoneImageType == 1) {
                background = `background-image: url(${customData.stoneSettings.stoneBigImage});`;
            }
            stoneDom += `
                <span class="cc-preview-stone-${index}" style="
                    left: ${tempset.x}px;
                    top: ${tempset.y}px; 
                    transform: rotate(${tempset.angle}deg) scale(${tempset.scale / 100}); 
                    background-attachment: fixed;
                    transform-origin: left top;
                    ${background}
                "><img src="" style="display: none; width: auto; height: auto;" /></span>
            `;
        }
    })
    $(".cc-popup-preview-stone-list").html(stoneDom);
}